// extracted by mini-css-extract-plugin
export default {"editButton":"onetimeAllowance_editButton__iGgS8","TableBody":"onetimeAllowance_TableBody__ZdWH3","deleteButton":"onetimeAllowance_deleteButton__hXk7W"};